export default __webpack_public_path__ + "static/media/icon-node-tipo-link.fff89631.svg";